var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marker arrow-bottom u-row t12 w7" }, [
    _c("div", { staticClass: "index" }, [_vm._v(_vm._s(_vm.index))]),
    _vm._v(" "),
    _c("p", { staticClass: "u-cut" }, [_vm._v(_vm._s(_vm.building.name))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }